import { CONTENT_SENSITIVITY } from './const';

export function getContentSensitivityLabelDescription(sensitivity) {
  switch (sensitivity.toLowerCase()) {
    case 'red':
      return CONTENT_SENSITIVITY.unsafe;
    case 'yellow':
      return CONTENT_SENSITIVITY.sensitive;
    default:
      return CONTENT_SENSITIVITY.safe;
  }
}

// As of 2021/07/08 in prod AC returns "safe", "sensitive" and "unsafe"
// values in a "reason" field, however, this is going to change to return
// more speicif reasons. To avoid downtime because of a difference in deployments
// between the platform and AC we'll hardcode some general purpose messages and
// deploy the FE first
export function normalizeContentSensitivityReason(reason) {
  switch (reason.toLowerCase()) {
    case 'safe':
      return 'The content of this variation is safe.';
    case 'sensitive':
      return 'The content of this variation may be sensitive.';
    case 'unsafe':
      return 'The content of this variation may be unsafe.';
    default:
      return reason;
  }
}
